import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ProductsState } from "./products.reducers";
import { Product } from "../../class/planProduct.class";
import { PlanProductModel } from "../../models/products.models";

export const selectProductsState = createFeatureSelector<ProductsState>('products');

export const selectAllPlans = createSelector(
  selectProductsState,
  (state: ProductsState) => state.plans
);

export const selectFreeProduct = createSelector(
  selectProductsState,
  (data: ProductsState) => data.plans?.classic ? new Product(data.plans.classic) : null
);

export const selectProProduct = createSelector(
  selectProductsState,
  (data: ProductsState) => data.plans?.premium ? new Product(data.plans.premium) : null
);

export const selectEntrepriseProduct = createSelector(
  selectProductsState,
  (data: ProductsState) => data.plans?.entreprise ? new Product(data.plans.entreprise) : null
);

export const selectProductById = (productId: string, periodicity: 'year' | 'month') => createSelector(
  selectProductsState,
  (state: ProductsState) => {
    if (!state.plans) return null;
    const productObj = Object.values(state.plans).find(
      (p: PlanProductModel) => new Product(p).getPricesIdByPerdiodicity(periodicity) === productId
    );
    return productObj ? new Product(productObj) : null;
  }
);

export const selectTokensPacks = createSelector(
  selectProductsState,
  (state: ProductsState) => state.tokensPacks || []
);
